import * as React from 'react'

import { arrowCounterClockwiseIcon, closeIcon, pauseIcon, playIcon, speakerIcon, squareIcon } from '../../images/index'

const BackpackIcon = ({ className = 'read-aloud-icon', src, }: { className?: string, src: string }) => <img alt="" aria-hidden="true" className={className} src={src} />

const CONTROL_ICON_CLASS = 'read-aloud-icon read-aloud-control-icon'

const SpeakerIcon = () => <BackpackIcon src={speakerIcon.src} />

const StopIcon = () => <BackpackIcon src={squareIcon.src} />

const CloseIcon = () => <BackpackIcon src={closeIcon.src} />

const PlayIcon = () => <BackpackIcon className={CONTROL_ICON_CLASS} src={playIcon.src} />

const PauseIcon = () => <BackpackIcon className={CONTROL_ICON_CLASS} src={pauseIcon.src} />

const RestartIcon = () => <BackpackIcon src={arrowCounterClockwiseIcon.src} />

export { CloseIcon, PauseIcon, PlayIcon, RestartIcon, SpeakerIcon, StopIcon }
